module.exports = __webpack_public_path__ + "static/media/header-mobile_v2.06d78439.jpg";